export const color = {
  main: "#004e89",
  white: "#FFFFFF",
  overlay: "#CCCCCC",
  background: "#F0F2F5",
  sidebar: "#D9D9D9",
  header: "#004e89",
  menu: "#CCCCCC",
  btn_primary: "#004e89",
  btn_hover_primary: "#1890ff",
  green: "#3CB371",
  orange: "#FF4500",
  red: "#FF0000",
  orange_red: "#E76145",
  mustardYellow: "#F4BB44",
  red_pink: "#F5B7B1",
  link: "#1890ff",
};
